import * as ActionTypes from './types';

export function deleteDepartment(payload) {
    return {
        type: ActionTypes.DELETE_DEPARTMENT,
        payload: payload
    }
}

export function deleteDepartmentSuccess(payload) {
  return {
    type: ActionTypes.DELETE_DEPARTMENT_SUCCESS,
    payload: payload
  }
}

export function deleteDepartmentFailed(payload) {
  return {
    type: ActionTypes.DELETE_DEPARTMENT_FAILED,
    payload: payload
  }
}

export function changeDepartmentState(payload) {
    return {
        type: ActionTypes.CHANGE_DEPARTMENT_STATE,
        payload: payload
    }
}

export function updateDepartment(payload) {
  return {
    type: ActionTypes.UPDATE_DEPARTMENT,
    payload: payload
  }
}

export function updateDepartmentSuccess(payload) {
  return {
    type: ActionTypes.UPDATE_DEPARTMENT_SUCCESS,
    payload: payload
  }
}

export function updateDepartmentFailed(payload) {
  return {
    type: ActionTypes.UPDATE_DEPARTMENT_FAILED,
    payload: payload
  }
}

export function getDepartmentById(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENT_BY_ID,
    payload: payload
  }
}

export function getDepartmentByIdSuccess(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENT_BY_ID_SUCCESS,
    payload: payload
  }
}

export function getDepartmentByIdFailed(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENT_BY_ID_FAILED,
    payload: payload
  }
}

export function createDepartment(payload) {
  return {
    type: ActionTypes.CREATE_DEPARTMENT,
    payload: payload
  }
}

export function createDepartmentSuccess(payload) {
  return {
    type: ActionTypes.CREATE_DEPARTMENT_SUCCESS,
    payload: payload
  }
}

export function createDepartmentFailed(payload) {
  return {
    type: ActionTypes.CREATE_DEPARTMENT_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/department.js